/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: CustomersSearchComponent
 * Purpose		: This component retrieves data for the specified records based on search supplied.
 * Dependency	: CustomersService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { Component, OnInit, HostBinding, EventEmitter, Input, Output,
         trigger, transition, animate,
         style, state } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/switchMap';

import { CustomersData, CustomersService }  from './Customers.service';


@Component({
  selector: 'CustomersSearch',
  template: require('./CustomersSearch.component.html'),
  providers: [CustomersService
	
	],
  animations: [
    trigger('routeAnimation', [
      state('*',
        style({
          opacity: 1,
          transform: 'translateX(0)'
        })
      ),
      transition(':enter', [
        style({
          opacity: 0,
          transform: 'translateX(100%)'
        }),
        animate('0.9s ease-in')
      ]),
      transition(':leave', [
        animate('0.5s ease-out', style({
          opacity: 0,
          transform: 'translateY(100%)'
        }))
      ])
    ])
  ]
})

export class CustomersSearchComponent implements OnInit {
	@Output() filterCriteria = new EventEmitter<string>();
	
	/* Animation for Search section */
	@HostBinding('@routeAnimation') get routeAnimation() {
		return true;
	}

	@HostBinding('style.display') get display() {
		return 'block';
	}

	// @HostBinding('style.position') get position() {
	//  return 'absolute';
	// }
 
	objCustomers: CustomersData;
	errorMessage: string;
	messages: string[];
	filterExpression: string;
	showSearch: boolean;

	// Lookup Arrays
	

	constructor(private route: ActivatedRoute, 
		private router: Router,
		private CustomersService: CustomersService

	) {
		// this.id = parseInt(params.get('id'));
		this.objCustomers = new CustomersData();
		/* Initialize Lookup field values
		this.objProducts.CategoryID = 0;
		this.objProducts.SupplierID = 0;
		*/
		this.filterCriteria = new EventEmitter<string>();
	}

	ngOnInit() {
		// Getting lookup data
		this.getLookups();
	}
	
	clearCriteria() {
		/* To empty values in textbox and dropdown lists
		this.objProducts.ProductName = '';
		this.objProducts.CategoryID = 0;
		this.objProducts.SupplierID = 0;
		*/
		this.objCustomers = new CustomersData();
		this.filterExpression = '';
		event.preventDefault();
		console.log(`Filter Changed: ${this.filterExpression}`);
		this.filterCriteria.emit(this.filterExpression);
	}
	
	onExpandCollapse()
	{
		this.showSearch = !this.showSearch;
	}
	
	searchProducts() {
		// Updating filterExpression on Search button click
		this.filterExpression = '';
		
		if (this.objCustomers.CustomerID)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND CustomerID like '%" + this.objCustomers.CustomerID + "%'";
			else
				this.filterExpression = "CustomerID like '%" + this.objCustomers.CustomerID + "%'";
		}
		if (this.objCustomers.CompanyName)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND CompanyName like '%" + this.objCustomers.CompanyName + "%'";
			else
				this.filterExpression = "CompanyName like '%" + this.objCustomers.CompanyName + "%'";
		}
		if (this.objCustomers.ContactName)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND ContactName like '%" + this.objCustomers.ContactName + "%'";
			else
				this.filterExpression = "ContactName like '%" + this.objCustomers.ContactName + "%'";
		}
		if (this.objCustomers.ContactTitle)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND ContactTitle like '%" + this.objCustomers.ContactTitle + "%'";
			else
				this.filterExpression = "ContactTitle like '%" + this.objCustomers.ContactTitle + "%'";
		}
		if (this.objCustomers.Address)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND Address like '%" + this.objCustomers.Address + "%'";
			else
				this.filterExpression = "Address like '%" + this.objCustomers.Address + "%'";
		}
		if (this.objCustomers.City)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND City like '%" + this.objCustomers.City + "%'";
			else
				this.filterExpression = "City like '%" + this.objCustomers.City + "%'";
		}
		if (this.objCustomers.Region)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND Region like '%" + this.objCustomers.Region + "%'";
			else
				this.filterExpression = "Region like '%" + this.objCustomers.Region + "%'";
		}
		if (this.objCustomers.PostalCode)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND PostalCode like '%" + this.objCustomers.PostalCode + "%'";
			else
				this.filterExpression = "PostalCode like '%" + this.objCustomers.PostalCode + "%'";
		}
		if (this.objCustomers.Country)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND Country like '%" + this.objCustomers.Country + "%'";
			else
				this.filterExpression = "Country like '%" + this.objCustomers.Country + "%'";
		}
		if (this.objCustomers.Phone)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND Phone like '%" + this.objCustomers.Phone + "%'";
			else
				this.filterExpression = "Phone like '%" + this.objCustomers.Phone + "%'";
		}
		if (this.objCustomers.Fax)
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND Fax like '%" + this.objCustomers.Fax + "%'";
			else
				this.filterExpression = "Fax like '%" + this.objCustomers.Fax + "%'";
		}

		
		/* Build Search here
		if (this.objProducts.ProductName)
		{
			this.filterExpression += "ProductName like '%" + this.objProducts.ProductName + "%'";
		}
		if (this.objProducts.CategoryID  && this.objProducts.CategoryID.toString() != "0")
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND CategoryID = " + this.objProducts.CategoryID;
			else
				this.filterExpression = "CategoryID = " + this.objProducts.CategoryID;
		}
		if (this.objProducts.SupplierID && this.objProducts.SupplierID.toString() != "0")
		{
			if (this.filterExpression.length > 0)
				this.filterExpression = this.filterExpression + " AND SupplierID = " + this.objProducts.SupplierID;
			else
				this.filterExpression = "SupplierID = " + this.objProducts.SupplierID;
		}
		*/
		event.preventDefault();
    	console.log(`Filter Changed: ${this.filterExpression}`);
		this.filterCriteria.emit(this.filterExpression);
	}



	getLookups() {

	}

	log(msg: string) {
		this.messages.splice(0, 0, msg);
		console.log(msg);
	}
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/Customers/CustomersSearch.component.ts